/*
 * View for a single substitution category
 */

define(["marionette", "./template/categoryInfoTemplate.html"], function (
  Marionette,
  CategoryInfoTemplate,
) {
  var CategoryInfoView = {};

  CategoryInfoView.categoryInfoLayout = Marionette.Layout.extend({
    template: CategoryInfoTemplate,
    nameError: function (errorMessage) {
      this.$el
        .find("#categoryNameText")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    regions: {
      categoryNameText: "#categoryNameText",
      categoryDescriptionText: "#categoryDescriptionText",
    },
    triggers: {
      "click #deleteCategory": "delete:category",
      "click #categoryUnfilterable": "toggle:unfilterable",
    },
  });

  return CategoryInfoView;
});
